import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
	selector: 'app-session-warning',
	templateUrl: './session-warning.component.html',
	styleUrls: ['./session-warning.component.scss']
})
export class SessionWarningComponent implements OnInit {
	public idleState: number | string;

	constructor(private _authenticationService: AuthenticationService,
				public snackbar: MatSnackBar) {
	}

	ngOnInit(): void {
		this._authenticationService.idleState$.subscribe((value) => {
			this.idleState = value;
		});
	}

}
